import { createSelector } from '@reduxjs/toolkit';

import getVehicles from './getVehicles';

const getColorsCode = createSelector(getVehicles, ({ vehicles }) => {
  const colorsCode: {
    [K: string]: { topHexCode: string; bodyHexCode: string };
  } = {};

  if (!vehicles) {
    return colorsCode;
  }

  vehicles.forEach(({ modifications }) => {
    modifications[0]?.grades.forEach(({ colors }) => {
      colors.forEach(({ colorName, bodyHexCode, topHexCode }) => {
        colorsCode[colorName.trim()] = {
          topHexCode,
          bodyHexCode,
        };
      });
    });
  });

  return colorsCode;
});

export default getColorsCode;
